import { render, staticRenderFns } from "./editProjectType.vue?vue&type=template&id=3e6ca758&"
import script from "./editProjectType.vue?vue&type=script&lang=js&"
export * from "./editProjectType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports